import { cn } from '../../lib/utils'
import { PhoneIncoming, PhoneOutgoing, Monitor } from 'lucide-react'
import { useDirectionLabel } from '../../i18n/statusLabels'

const directionStyles: Record<string, { style: string; icon: typeof PhoneIncoming }> = {
  inbound: { style: 'bg-info/20 text-info', icon: PhoneIncoming },
  outbound: { style: 'bg-warning/20 text-warning', icon: PhoneOutgoing },
  browser: { style: 'bg-primary/20 text-primary', icon: Monitor },
}

export function DirectionBadge({ direction }: { direction: string }) {
  const config = directionStyles[direction] || directionStyles.inbound
  const Icon = config.icon
  const label = useDirectionLabel(direction)
  return (
    <span className={cn('inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium', config.style)}>
      <Icon className="h-3 w-3" />
      {label}
    </span>
  )
}
